'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, t) {
    if (null == e) return {};
    var r, o, n = _object_without_properties_loose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(o = 0; o < s.length; o++)r = s[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
    }
    return n;
}
function _object_without_properties_loose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, s = Object.keys(e);
    for(o = 0; o < s.length; o++)r = s[o], t.indexOf(r) >= 0 || (n[r] = e[r]);
    return n;
}
const StepIndicatorStepValue = renderWithRef('StepIndicatorStepValue', null, (r, o)=>{
    var { children: n, skin: s = 'standard' } = r, p = _object_without_properties(r, [
        "children",
        "skin"
    ]);
    let a = new Set([
        'swan-step-value'
    ]);
    return 'standard' !== s && a.add(`swan-step-value-skin-${s}`), jsx(RenderComp, {
        root: "span",
        classNames: a,
        forwardedRef: o,
        props: p,
        children: n
    });
});

export { StepIndicatorStepValue };
